namespace TabAurous.ProductDevelopment {
    export interface StageMembersRow {
        MemeberId?: number;
        StageId?: number;
        MemberName?: string;
        Email?: string;
        Comment?: boolean;
        Decision?: boolean;
        Manage?: boolean;
        Share?: boolean;
    }

    export namespace StageMembersRow {
        export const idProperty = 'MemeberId';
        export const nameProperty = 'MemberName';
        export const localTextPrefix = 'ProductDevelopment.StageMembers';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            MemeberId = "MemeberId",
            StageId = "StageId",
            MemberName = "MemberName",
            Email = "Email",
            Comment = "Comment",
            Decision = "Decision",
            Manage = "Manage",
            Share = "Share"
        }
    }
}
